import { SHIPPING_GROUP_NAMES } from '@/constants/delivery';

export const checkProductPickupType = (pickupType) =>
  ({ availability }) => availability?.pickup?.some(pickup => pickup.type === pickupType);

export const getPickupGroupsWithStoreType = ({ type, products }) => type === SHIPPING_GROUP_NAMES.pickup && products.some(checkProductPickupType('store'));
